<template>
    <div class="pt-3">
        <div class="d-flex">
            <v-alert type="info" text>Ordene os grupos.</v-alert>
        </div>
    
    <div class="sitemap-boxes">
        <div  v-for="(block, b) in all" :key="b">
                        <v-item>
        <v-card class="pa-2" outlined  @dragover="(e) => onDragOver(block, b, e)"
                                @dragend="(e) => finishDrag(block, b, e)" @dragstart="(e) => startDrag(block, b, e)"
                                draggable="true">
            <h4 class="ml-n1 pb-2 d-flex">
                <span>
                    {{ block.title }}
                </span>
                <v-spacer></v-spacer>
                <v-btn icon class="mx-1" @click="editBlock(b)"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn icon color="error" @click="removeBlock(b)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
            </h4>
            <v-list>
                <v-list-item-group>

                    <template v-for="(item, i) in block.items">
                        
                            <v-list-item :key="i" :href="item.link.includes('https://') ? item.link : `https://`" class="ml-n1"
                                :target="item.target">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            
                       
                    </template>
                </v-list-item-group>
                <!-- <li class="--read" v-if="block.items.length > settings.limitPerBlock">
                    <a class="ml-n1"
                        @click="block.more = !block.more" text small><strong>{{
                            showing(block.more) }}</strong></a>
                </li> -->
            </v-list>
        </v-card>
        </v-item>
    </div>

        <v-card color="success" class="d-flex justify-center align-center" @click="addBlock()">
            <h4 class="white--text">Adicionar grupo</h4>
        </v-card>
        <v-dialog v-model="blockDialog.show" width="540">
            <v-card>
                <v-card-title v-if="indexBlock == -1">Adicionar grupo</v-card-title>
                <v-card-title v-else>Editar grupo</v-card-title>
                <v-card-text>
                    <v-text-field outlined v-model="blockDialog.title" label="Título do grupo"></v-text-field>
                    <v-list>
                        <v-subheader>Links:</v-subheader>
                        <p class="pa-4" v-if="!blockDialog.items.length"><em>Nenhum link no grupo</em></p>
                        <v-list-item-group color="primary">
                            <v-list-item v-for="(item, i) in blockDialog.items" :key="i">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon>
                                    <v-icon @click="editLink(i)" class="mx-2">mdi-pencil</v-icon>
                                    <v-icon @click="removeLink(i)">mdi-trash-can-outline</v-icon>
                                </v-list-item-icon>
                            </v-list-item>

                            <div class="px-3">
                                <v-btn outlined block color="success" @click="addLink()">Adicionar link</v-btn>
                            </div>
                        </v-list-item-group>
                    </v-list>




                    <div class="pt-3 d-flex">
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancelBlock()" class="mx-1">Cancelar</v-btn>
                        <v-btn color="success" :loading="saving" elevation="0" @click="saveBlock()">Salvar</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="linkDialog.show" width="480">
            <v-card>
                <v-card-title>Adicionar link</v-card-title>
                <v-card-text>
                    <v-text-field outlined v-model="linkDialog.text" label="Texto"></v-text-field>
                    <v-text-field outlined v-model="linkDialog.link" label="URL"></v-text-field>
                    <v-switch outlined v-model="linkDialog.switch"
                        :label="linkDialog.target == '_blank' ? 'Abrir em nova aba' : 'Abrir na mesma aba'"></v-switch>
                    <div class="pt-3 d-flex">
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancelLink()">Cancelar</v-btn>
                        <v-btn color="success" elevation="0" @click="saveLink()">Salvar</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="removeBlockDialog.show" width="480">
            <v-card>
                <v-card-title>Remover grupo</v-card-title>
                <v-card-text>
                    <p>Ao remover o grupo, todos os links contidos nele serão removidos permanentemente.</p>
                    <p>Deseja realmente remover?</p>
                    <div class="pt-3 d-flex">
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancelRemoveBlock()">Cancelar</v-btn>
                        <v-btn color="success" elevation="0" @click="confirmRemoveBlock()">Remover</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
    </div>
</template>

<script>
import { initializeApp } from "firebase/app";
import {
    getFirestore, doc, updateDoc,
    collection,
    query,
    deleteDoc,
    setDoc,
    getDoc,
    getDocs,
} from "firebase/firestore";
import config from "@/store/config"
import { mapState, mapActions } from "vuex";

export default {

    data: () => ({
        dragover: false,
        over: {},
        startLoc: 0,
        dragging: false,
        dragFrom: {},
        indexBlock: -1,
        all: [],
        loading: false,
        saving: false,
        settings: {
            limitPerBlock: 100
        },
        blockDialog: {
            show: false,
            title: "",
            items: []
        },
        removeBlockDialog: {
            show: false,
            index: -1
        },
        linkDialog: {
            index: -1,
            show: false,
            loading: false,
            link: "",
            target: "",
            text: ""
        }
    }),
    created() {

    },
    mounted() {
        this.loadSitemap()
    },
    computed: {
        ...mapState("groupStores", [
            "allStores"]),
        masterStore() {
            let list = []
            this.allStores.forEach((inv) => {
                if (inv.master == true) {
                    return inv
                }
            })
            return list
        }
    },
    watch: {
        'linkDialog.switch': {
            deep: true,
            handler(v) {
                this.linkDialog.target = v ? '_blank' : '_self'
            }
        }
    },
    methods: {
        ...mapActions("snackbar", ["showSnack"]),
        confirmRemoveBlock(){
            this.all.splice(this.removeBlockDialog.index, 1)
            this.saveBlock(true)
            this.removeBlockDialog.index = -1
            this.removeBlockDialog.show = false
        },
        startDrag(item, i, e) {
            this.startLoc = e.clientY;
            this.dragging = true;
            this.dragFrom = item;
        },
        finishDrag(item, pos) {
            this.all.splice(pos, 1);
            this.all.splice(this.over.pos, 0, item);
            this.over = {};
        },
        onDragOver(item, pos, e) {
            const dir = this.startLoc < e.clientY ? "down" : "up";
            setTimeout(() => {
                this.over = { item, pos, dir };
            }, 50);
        },
        removeBlock(index){
            this.removeBlockDialog.index = index
            this.removeBlockDialog.show = true
        },
        cancelRemoveBlock(){
            this.indexBlock = -1
            this.removeBlockDialog.show = true
        },
        addBlock() {
            this.indexBlock = -1
            this.blockDialog.title = ""
            this.blockDialog.items = []
            this.blockDialog.show = true
        },
        addLink() {
            this.linkDialog.text = ""
            this.linkDialog.target = "_self"
            this.linkDialog.link = ""
            this.linkDialog.index = -1
            this.linkDialog.show = true
        },
        removeLink(index){
            this.blockDialog.items.splice(index, 1)
        },
        editLink(index) {
            const blockItems = this.all[this.indexBlock].items
            const linkItem = blockItems[index]
            this.linkDialog.index = index
            this.linkDialog.target = linkItem.target
            this.linkDialog.link = linkItem.link
            this.linkDialog.text = linkItem.text
            this.linkDialog.show = true
        },
        editBlock(index){
            this.indexBlock = index
            this.blockDialog.items = this.all[index].items
            this.blockDialog.title = this.all[index].title
            this.blockDialog.show = true
        },
        cancelLink() {
            this.linkDialog.show = false
        },
        cancelBlock() {
            this.saving = false
            this.blockDialog.title = ""
            this.blockDialog.show = false
        },

        

        loadSitemap() {
            this.loading = true
            const firebase = initializeApp(config);
            const db = getFirestore(firebase)
            const docRef = doc(db, "sitemap", 'basic');
            getDoc(docRef).then((document) => {
                if (document.exists()) {
                    const snapDoc = document.data()
                    const item = JSON.parse(JSON.stringify(snapDoc))
                    this.settings = item.config
                    item.blocks.forEach(block => {
                        block.more = false
                        this.all.push(block)
                    })
                }
                this.loading = false
            })
        },
        saveLink() {
            const item = {
                text: this.linkDialog.text,
                link: this.linkDialog.link,
                target: this.linkDialog.target
            }
            if(this.linkDialog.index == -1)
            this.blockDialog.items.push(item)
            else
                this.blockDialog.items[this.linkDialog.index] = item
            this.linkDialog.show = false

        },
        saveBlock(saveOnly = false) {
            
            const all = JSON.parse(JSON.stringify(this.all))
            this.saving = true
            if(!saveOnly){
                const item = {
                    title: this.blockDialog.title,
                    items: this.blockDialog.items
                }
                if (this.indexBlock == -1)
                    all.push(item)
                else
                    all[this.indexBlock] = item
            }
            const form = {
                blocks: all,
                config: {
                    limitPerBlock: 5
                }
            }

            const firebase = initializeApp(config);
            const db = getFirestore(firebase);
            console.log("BASIC FORM", form)
            setDoc(doc(db, "sitemap", "basic"), form).then(() => {
                this.showSnack({
                    text: 'Sitemap salvo com sucesso',
                    color: "success",
                    timeout: 3800,
                    icon: "mdi-check",
                });
                this.blockDialog.show = false
                this.all = all
                this.saving = false
            })
        }

    }
}
</script>
<style>
.sitemap-boxes {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px;
}
</style>